import { animate, group, query as q, style, transition, trigger } from '@angular/animations';

export function query(style_, animate_, optional = {optional: true}) {
    return q(style_, animate_, optional);
}

const fade = [
    query(':enter, :leave', style({position: 'fixed', width: '100%'})),
    query(':enter', [style({opacity: 0})]),
    group([
        query(':leave', [animate('0.3s ease-out', style({opacity: 0}))]),
        query(':enter', [
            style({opacity: 0}),
            animate('0.3s ease-out', style({opacity: 1})),
        ]),
    ]),
];

const fadeInFromDirection = direction => [
    query(':enter, :leave', style({position: 'fixed', width: '100%'})),
    group([
        query(':enter', [
            style({
                transform: `translateX(${direction === 'backward' ? '-' : ''}15%)`,
                opacity: 0,
            }),
            animate(
                '0.3s ease-out',
                style({transform: 'translateX(0%)', opacity: 1}),
            ),
        ]),
        query(':leave', [
            style({transform: 'translateX(0%)'}),
            animate('0.3s ease-in', style({opacity: 0})),
        ]),
    ]),
];

const fadeInFromRight = [
    query(':enter, :leave', style({position: 'fixed', width: '100%'})),
    group([
        query(':enter', [
            style({
                transform: `translateX(100%)`,
                opacity: 1,
            }),
            animate(
                '0.3s ease-out',
                style({transform: 'translateX(0%)', opacity: 1}),
            ),
        ]),
        query(':leave', [
            style({transform: 'translateX(0%)'}),
            animate('0.3s ease-in', style({opacity: 1, transform: 'translateX(-50%)'})),
        ]),
    ]),
];

const fadeOutToRight = [
    query(':enter, :leave', style({position: 'fixed', width: '100%'})),
    group([
        query(':enter', [
            style({
                transform: `translateX(-50%)`,
                opacity: 1,
            }),
            animate(
                '0.3s ease-out',
                style({transform: 'translateX(0%)', opacity: 1}),
            ),
        ]),
        query(':leave', [
            style({transform: 'translateX(0%)'}),
            animate('0.3s ease-out', style({opacity: 1, transform: 'translateX(100%)'})),
        ]),
    ]),
];

export const routerTransition = trigger('routerTransition', [
    transition('* => inital', fade),
    transition('* => section', fade),
    transition('* => forward', fadeInFromRight), // fadeInFromDirection('forward')),
    transition('* => backward', fadeOutToRight)// fadeInFromDirection('backward')),
]);
